import "../../styles/speakersHP.scss";
import DP from "../../images/DanPena.webp";
import JW from "../../images/Watt1.webp";
import SW from "../../images/SW.webp";
import AH from "../../images/AH.webp";
import PS from "../../images/scanlon.webp";
import PM from "../../images/Phillip.webp";
import RD from "../../images/RD.webp";
import GR from "../../images/GR.webp";
import JP from "../../images/jp.webp";
import LR from "../../images/LR.webp";
import Paul from "../../images/PAUL.webp";
import SBCBanner from "../../images/SBCBanner.webp";
// import coneImage from "../../images/cone.png";
import Carousel from "react-grid-carousel";
import SpeakerCard from "./SpeakerCard";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import GS from '../../images/GREG.webp'

import { useState, useRef } from "react";

const testimonialData = [
  {
    name: "Paul McFadden",
    summary: `Paul McFadden is one of the UK’s leading voices in wealth creation, property investment, and business growth.\n\nWith two decades of experience, he has helped thousands of people rethink how they approach business, money, and success, mentoring them to build lasting wealth, scale with purpose, and achieve true financial freedom.\n\nPaul is known for simplifying complex strategies and inspiring decisive action, Paul has built and scaled multiple seven and eight-figure companies across property, education, finance, and media.\n\nAt the Scottish Business Conference, he will share the mindset shifts, growth strategies, and proven principles behind his 8 Pillars of Business Success framework, revealing exactly how he and countless others have scaled to seven and eight figures.`,
    img: Paul,
  },
  {
    name: "Paul Scanlon",
    summary:
      "With over 30 years’ experience, Paul Scanlon has helped individuals and organisations unlock their potential through personal growth and leadership.\n\n At SBC 2025, he’ll share how to embrace change, think differently, and lead with authenticity, giving you the confidence to step into your full potential in business and life.",
    img: PS,
  },
  {
    name: "Philip Mckernan",
    summary:
      "Philip McKernan is an internationally sought-after speaker and mentor, known for helping people connect deeply with their true purpose and live a life that matters.\n\nAt SBC 2025, he’ll help you uncover what’s holding you back, gain clarity on your path, and step into a more authentic, impactful version of yourself.",
    img: PM,
  },
  {
    name: "Richard Dickson",
    summary:
      "Richard Dickson is an award-winning entrepreneur and the founder of Growth Getters, a company dedicated to helping businesses scale through smart digital marketing, paid traffic, and automation.\n\n Recognised as Scottish Young Entrepreneur of the Year, Richard has guided hundreds of business owners across the UK to achieve predictable, sustainable growth. He is also co-creator of The Six Figure Coach, an exclusive programme with Paul McFadden that helps experts and educators build multi-six and seven-figure coaching businesses. \n\nRichard specialises in simplifying systems, sharpening marketing, and driving scale without sacrificing customer experience.",
    img: RD,
  },
  {
    name: "Gary Rhodes",
    summary:
      "Gary Rhodes is a dedicated health advocate on a mission to put bone health screening at the heart of UK healthcare.\n\n With over a decade of experience, he founded Screen My Bones to tackle one of the leading causes of workplace absenteeism: musculoskeletal health. Gary is driving a proactive, accessible approach to osteoporosis prevention, aiming to reduce long-term healthcare costs and improve national wellbeing.",
    img: GR,
  },
  {
    name: "Jon Penberthy",
    summary:
      "Jon Penberthy is recognised as one of the leading experts in turning online traffic into hight-value customers and clients at scale.\n\nHis campaigns have been viewed over 300 million times, he has built email lists in the hundreds of thousands, and he has scaled multiple companies to seven figures, including one to eitght figures.\n\nThrough his coaching company, AdClients, Jon has helped entrepreneurs generate more than $122M in reported revenue. Jon has featured in Forbes and Success Magazine for his impact on the online education industry and has also founded the UK's largest marketing conference for online entrepreneurs AdCon.",
    img: JP,
  },
  {
    name: "Liam Ryan",
    summary: `Liam J Ryan is a highly regarded international speaker, accomplished business wealth creation expert, and successful entrepreneur. He's also the co-founder of Assets For Life, the UK’s leading property, business and wealth education company, known for empowering individuals to achieve genuine financial independence. Drawing from years of building multi-million-pound businesses, Liam now focuses on stock market investment, translating financial strategies into clear, actionable insights.\n\nHe's a compelling speaker, sharing his wealth accumulation experience, particularly with his 14 stock market strategies which he uses to compound his legacy. As a best-selling
author and host of the Beyond The Hustle Podcast, Liam has refined strategies leading
to tangible financial success. His approach exemplifies strategic investment and
effective income generation in the stock market and beyond.`,
    img: LR,
  },
  {
    name: "Greg Summers",
    summary: `Greg Summers has spent the last 30 years immersed in Sales, Communications, Media and Entertainment.\n\nHis career has taken him from leading a sales team within a large Scottish company, responding to media crises within organisations, Presenting on TV and Online and fronting some of the biggest events in the UK with with recognised Celebrities, Business leaders, Elite athletes and Politicians.\n\nGreg’s current focus is helping communities Speak and Sell Better.\n\nWe look forward to Greg hosting all 3 days on the main 
    stage and delivering a one hour Presentation on his 10 tips of Gold towards Improved Communication which will be on show at The Scottish Business Conference.`,
    img: GS,
  },
];

export default function SpeakersHP({ handleCone, affiliate = false }) {
  const [speakers, setSpeakers] = useState(0);
  const [showSpeakers, setShowSpeakers] = useState(false);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const carouselRef = useRef();

  const handleArrowClick = (direction) => {
    const totalItems = testimonialData.length;
    const itemsPerSlide = 3; // match your Carousel `cols` value
    const maxIndex = Math.ceil(totalItems / itemsPerSlide) - 1;

    setCarouselIndex((prevIndex) => {
      let newIndex;
      if (direction === "left") {
        newIndex = prevIndex === 0 ? maxIndex : prevIndex - 1;
      } else {
        newIndex = prevIndex === maxIndex ? 0 : prevIndex + 1;
      }

      // Move the carousel to the new index
      carouselRef.current?.goTo(newIndex);
      return newIndex;
    });
  };

  return (
    <main className="speakers__main" id="speakers">
      <h2>Meet Your Speakers</h2>
      <h6>
        Successful entrepreneurs who’ve built 7 and 8 figure businesses, sharing
        hands on experience you can use to{" "}
        <span>grow, scale, and increase profits. </span>
      </h6>
      <section className="key__note">
        <aside className="bio">
          <h3>Dan Peña</h3>
          <h4>The Trillion Dollar Man</h4>
          <p>
            Known globally as The Trillion Dollar Man, Dan Peña is one of the
            most ruthless and relentless high performance business coaches in
            the world. His methods have helped create over a trillion dollars in
            wealth for his mentees. 
          </p>
          <p>
            At SBC 2025, he’ll share the unfiltered truth on what it takes to
            win big, and why most never make it. Whether you agree with his
            style or not, one thing is for certain: you’ll leave thinking
            bigger, acting bolder, and ready to raise your standards. 
          </p>
        </aside>
        <img src={DP} alt="Dan Peña" />
      </section>
      <section className="key__note">
        <aside className="bio">
          <h3>James Watt</h3>
          <h4>Co-Founder of BrewDog</h4>
          <p>
            James Watt turned a small Scottish brewery into a billion dollar
            global brand, making BrewDog one of the most recognised names in the
            drinks industry. 
          </p>
          <p>
            Known for his disruptive approach and bold marketing, James has
            redefined what’s possible for an independent business. At SBC 2025,
            he’ll share the key moves and mindset shifts that took BrewDog from
            a garage operation to an international powerhouse, leaving you
            inspired and ready to take action. 
          </p>
        </aside>
        <img src={JW} alt="James Watt" />
      </section>
      <section className="key__note">
        <aside className="bio">
          <h3>Sarah Willingham </h3>
          <h4 className="wide--line">
            Serial Entrepreneur, Investor & Former Dragon 
          </h4>
          <p>
            Best known for her role on BBC’s Dragons’ Den, Sarah Willingham has
            built and scaled multiple businesses from restaurants to consumer
            brands, creating wealth with purpose. 
          </p>
          <p>
            With decades of experience in investing and mentoring founders, she
            knows what it takes to turn great ideas into profitable, sustainable
            ventures. At SBC 2025, she’ll share the lessons and mindset behind
            her success, inspiring you to think bigger, act decisively, and
            build a business that thrives and makes a real impact. 
          </p>
        </aside>
        <img src={SW} alt="Sarah Willingham" />
      </section>
      <section className="key__note">
        <aside className="bio">
          <h3>Anna-Sophie Hartvigsen </h3>
          <h4 className="wide--line">
            Co-Founder of Female Invest & Forbes 30 Under 30 
          </h4>
          <p>
            Anna-Sophie Hartvigsen is the co-founder of Female Invest, one of
            Europe’s fastest growing financial education platforms for women,
            and a Forbes 30 Under 30 honouree. 
          </p>
          <p>
            Passionate about closing the gender gap in investing, she has helped
            thousands of women take control of their finances and build lasting
            wealth. At SBC 2025, Anna-Sophie will share how she turned a purpose
            driven idea into a global movement, and how you can combine mission
            with growth to build a business that matters.
          </p>
        </aside>
        <img src={AH} alt="Anna Hartvigsen" />
      </section>
      <section className="more__speakers">
        <h2>More Speakers to be Announced</h2>
        {/* {!affiliate ? (
          <img
            src={coneImage}
            alt="cone"
            className="cone2"
            id="cone2"
            onClick={() => handleCone(2, "cone2")}
          />
        ) : null} */}
        <img src={SBCBanner} alt="Speaker list" />
      </section>
      {/* SPEAKER CAROUSEL */}
      <section className="speaker-carousel ">
        <Carousel
          ref={carouselRef}
          cols={3}
          rows={1}
          gap={20}
          loop
          arrowLeft={
            <button
              onClick={() => handleArrowClick("left")}
              className="custom-arrow left"
            >
              <ChevronLeftIcon fontSize="large" />
            </button>
          }
          arrowRight={
            <button
              onClick={() => handleArrowClick("right")}
              className="custom-arrow right"
            >
              <ChevronRightIcon fontSize="large" />
            </button>
          }
          responsiveLayout={[
            {
              breakpoint: 1200,
              cols: 2,
              rows: 1,
              gap: 15,
            },
            {
              breakpoint: 900,
              cols: 1,
              rows: 1,
              gap: 15,
            },
          ]}
        >
          {testimonialData.map((data, idx) => (
            <Carousel.Item key={idx}>
              <SpeakerCard {...data} resetSignal={carouselIndex} />
            </Carousel.Item>
          ))}
        </Carousel>
      </section>
    </main>
  );
}
